import React, { Component } from "react";
import { Zoom } from "react-reveal";
import Slide from "react-reveal";
import Zmage from "react-zmage";
import Fade from "react-reveal";
import "./style.css";

class Resume extends Component {
  getRandomColor() {
    let letters = "0123456789ABCDEF";
    let color = "#";
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }

  render() {
    if (!this.props.data) return null;

    const skillmessage = this.props.data.skillmessage;
    const education = this.props.data.education.map(function (education) {
      return (
        <div key={education.school}>
          <h4 style={{ color: " rgba(0, 148, 141, 0.678)" }}>
            {" "}
            {education.degree}
          </h4>
          <p>{education.description2}</p>
        </div>
      );
    });

    const work = this.props.data.work.map(function (work) {
      return (
        <div key={work.company}>
          {work.company ? (
            <h4 style={{ color: " rgba(0, 148, 141, 0.678)" }}>
              {work.company}
            </h4>
          ) : (
            <h6 style={{ color: " rgba(0, 148, 141, 0.678)" }}>
              {work.vision}
            </h6>
          )}

          <p className="info">
            {work.title}
            <span>&bull;</span> <em className="date">{work.years}</em>
          </p>
          <p>{work.description}</p>
        </div>
      );
    });

    const criticalMassEthiopia = this.props.data.cme.map(function (cme) {
      return (
        <div key={cme.company}>
          {cme.company ? (
            <h4 style={{ color: " rgba(0, 148, 141, 0.678)" }}>
              {cme.company}
            </h4>
          ) : (
            <h6 style={{ color: " rgba(0, 148, 141, 0.678)" }}>{cme.vision}</h6>
          )}

          <p className="info">
            {cme.title}
            <span>&bull;</span> <em className="date">{cme.years}</em>
          </p>
          <p>{cme.description}</p>
        </div>
      );
    });

    // const skills = this.props.data.skills.map((skills) => {
    //   const backgroundColor = this.getRandomColor();
    //   const className = "bar-expand " + skills.name.toLowerCase();
    //   const width = skills.level;

    //   return (
    //     <li key={skills.name}>
    //       <span style={{ width, backgroundColor }} className={className}></span>
    //       <em>{skills.name}</em>
    //     </li>
    //   );
    // });

    return (
      <section id="resume">
        <div className="cycle">
          <div className="community">
            <Zoom>
              <h3
                className="row education center"
                style={{ color: " rgba(0, 148, 141, 0.678)" }}
              >
                {" "}
                Egre Menged Community-based Cycling Project
              </h3>
              <p className="row education">
                {" "}
                is a community-based project by Egre Menged and has been
                functioning in Addis Ababa since February 2021. Egre Menged uses
                bicycles as a powerful tool to create new jobs, protect the
                environment and empower communities. It is a community group
                that rides bicycles on a weekly basis and advocates for a
                bicycle-friendly city. Under Egre Menged Community-based Cycling
                Project, three projects have been launched:
              </p>
            </Zoom>
            <div className="community">
              <Slide left duration={1300}>
                <div className="row education">
                  <div className="three columns header-col">
                    <h1>
                      <img
                        src="/images/1(1).png "
                        alt="free style cycling images"
                      />
                      <img
                        src="/images/1(2).png"
                        alt="free style cycling images"
                      />
                    </h1>
                  </div>

                  <div className="nine columns main-col">
                    <div className="row item">
                      <div className="twelve columns">{education}</div>
                    </div>
                  </div>
                  <div className="nine columns main-col">
                    <div className="row item">
                      <div className="twelve columns">
                        CYCLEmmunity actively advocates for the Sustainable
                        Development Goals (SDGs) as cycling is delivering on
                        these goals worldwide. For mankind and the environment,
                        it is crucial to increase transportation sustainability.
                        Furthermore, all levels of government should ensure
                        equal participation of all people in road transport
                        through mobility. Therefore, Egre Menged CYCLEmmunity
                        set a big focus with its work on SDG 11, Sustainable
                        Cities and Community, SDG 3, Good health and well-being,
                        and SDG 5, Gender Equality.
                      </div>
                    </div>
                  </div>
                </div>
              </Slide>
            </div>
          </div>
          <div className="cycle">
            <Slide left duration={1300}>
              <div id="cycle_tchialesh" className="row work">
                <div className="three columns header-col">
                  <h1>
                    <img src="/images/6.png " alt="free style cycling images" />
                    <img src="/images/9.png" alt="free style cycling images" />
                    <img src="/images/8.png" alt="free style cycling images" />
                  </h1>
                </div>

                <div className="nine columns main-col">{work}</div>
              </div>
            </Slide>
          </div>
        </div>
        <div className="community1">
          <Slide left duration={1300}>
            <div className="row work">
              <div className="three columns header-col">
                <h1>
                  {/* <img src="/images/1 (1).png " alt="free style cycling images" />
                <img src="/images/1 (2).png" alt="free style cycling images" /> */}
                  <img src="/images/10.png" alt="free style cycling images" />
                </h1>
              </div>

              <div className="nine columns main-col">
                {criticalMassEthiopia}
              </div>
            </div>
          </Slide>
        </div>
      </section>
    );
  }
}

export default Resume;
